import { Validators } from '@angular/forms';

import { FieldsOptions } from '@sim/form';

export interface Relation {
  tipo: string;
  descrizione: string;
}

export const RelationOAMeta: FieldsOptions<Relation & { beneOA: string }> = {
  beneOA: { validators: Validators.required },
  descrizione: { value: '' },
  tipo: { value: '' },
};

export const RelationFMeta: FieldsOptions<Relation & { beneF: string }> = {
  beneF: { validators: Validators.required },
  descrizione: { value: '' },
  tipo: { value: '' },
};

export const RelationMIMeta: FieldsOptions<Relation & { beneMI: string }> = {
  beneMI: { validators: Validators.required },
  descrizione: { value: '' },
  tipo: { value: '' },
};

export const RelationSMeta: FieldsOptions<Relation & { beneS: string }> = {
  beneS: { validators: Validators.required },
  descrizione: { value: '' },
  tipo: { value: '' },
};

export const RelationDMeta: FieldsOptions<Relation & { beneD: string }> = {
  beneD: { validators: Validators.required },
  descrizione: { value: '' },
  tipo: { value: '' },
};
